// src/components/TradingRules.tsx
import type { TradingRules as TradingRulesType } from '../types';

export function TradingRules({ rules }: { rules: TradingRulesType }) {
  if (!rules || rules.length === 0) {
    return (
      <div className="bg-white/10 text-yellow-200 p-6 rounded-xl shadow text-center">
        ⚠️ Trading rules are not available yet. This section will be updated soon.
      </div>
    );
  }

  return (
    <div className="bg-white/10 p-6 rounded-xl shadow text-yellow-100">
      <h3 className="text-2xl font-bold mb-4 text-yellow-400">Trading Rules</h3>
      <ul className="list-disc space-y-2 pl-6">
        {rules.map((rule, i) => (
          <li key={i} className="text-yellow-100">{rule}</li>
        ))}
      </ul>
    </div>
  );
}
